import Button from 'components/Button'
import { useRef, useState } from 'react'
import styled from 'styled-components'

const Tags = ({ tags, activeTags, setActiveTag, onePerLine }) => {
  const ref = useRef()
  const containerRef = useRef()

  const [showLeft, setShowLeft] = useState(false)
  const [showRight, setShowRight] = useState(true)

  const scroll = (direction) => {
    const tagContainer = (ref.current as any);
    const tagScroll = tagContainer.scrollLeft
    const newScrollX = direction === 'right' ? tagScroll + 300 : tagScroll - 300
    tagContainer.scrollTo({
      top: 0,
      left: newScrollX,
      behavior: 'smooth'
    })
  }

  const onScroll = () => {
    const tagContainer = (ref.current as any)
    const tagScroll = tagContainer.scrollLeft
    tagScroll === 0
      ? setShowLeft(false)
      : showLeft
          ? null
          : setShowLeft(true)
  }

  return (
    <S_Container ref={containerRef}>
      <S_Tags ref={ref} onScroll={onScroll}>
        {
          tags.map((tag, index) => 
            <S_ButtonContainer onePerLine={onePerLine} key={`tag${index}`}>
              <Button 
                text={tag} 
                emphasize={activeTags.includes(tag)}
                onClickFunction={() => setActiveTag(tag)} 
                outline={!activeTags.includes(tag)}
              />
            </S_ButtonContainer>
          )
        }
      </S_Tags>

      {
        showLeft
          ? <S_Overlay_L onClick={() => scroll('left')}>
              <S_Icon className='fa fa-chevron-circle-left' />
            </S_Overlay_L>
          : null
      }

      {
        showRight
          ? <S_Overlay onClick={() => scroll('right')}>
              <S_Icon className='fa fa-chevron-circle-right' />
            </S_Overlay>
          : null
      }
    </S_Container>
  )
}

export default Tags

const S_Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const S_Tags = styled.div`
  width: calc(100% - 32px);
  display: flex;
  padding: 0 16px;
  position: relative;
  left: 0;
  top: 0;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`

const S_ButtonContainer = styled.div`
  display: inline-block;
  margin-right: 8px;
`

const S_Overlay = styled.div`
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 0;
  height: 100%;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Gradient_To_Right);
  color: var(--Font_Color_Label);
  transition: all .3;

  &:hover {
    color: var(--Font_Color);
  }
  cursor: pointer;
`

const S_Overlay_L = styled.div`
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 0;
  height: 100%;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Gradient_To_Left);
  transition: all .3;
  color: var(--Font_Color_Label);
  &:hover {
    color: var(--Font_Color);
  }
  cursor: pointer;
`

const S_Icon = styled.i`
  font-size: var(--Font_Size_Icon);
`